<script setup lang="ts">
import { XModal, XButton, XLink } from '@clicksign/excalibur';
import { useI18n, I18nT } from '#i18n';

  type FacialBiometricsHeloModalEmit = {
    (e: 'close'): void;
  };

const emit = defineEmits<FacialBiometricsHeloModalEmit>();

function closeModal() {
  emit('close');
}

const { t } = useI18n();
</script>

<template>
  <XModal
    is-open
    persistent
    scrollable
    data-testid="facialBiometricsHelpModal"
    @close="closeModal"
  >
    <template #header>
      {{ t('requirement.facialBiometrics.modal.help.title') }}
    </template>

    <div :class="$style.helpTextContainer">
      <h5 :class="$style.helpTitle">
        {{ t('requirement.facialBiometrics.modal.help.whatIs.title') }}
      </h5>
      <span>
        {{ t('requirement.facialBiometrics.modal.help.whatIs.description') }}
      </span>
    </div>

    <div :class="$style.helpTextContainer">
      <h5 :class="$style.helpTitle">
        {{ t('requirement.facialBiometrics.modal.help.why.title') }}
      </h5>
      <span>
        {{ t('requirement.facialBiometrics.modal.help.why.description') }}
      </span>
    </div>

    <div :class="$style.helpTextContainer">
      <I18nT
        tag="span"
        keypath="requirement.facialBiometrics.modal.help.learnMore.base"
      >
        <XLink
          to="https://www.clicksign.com/politica-de-privacidade/"
          target="_blank"
          is-inline
        >
          {{ t('requirement.facialBiometrics.modal.help.learnMore.privacyPolicy') }}
        </XLink>
        <XLink
          to="https://ajuda.clicksign.com/"
          target="_blank"
          is-inline
        >
          {{ t('requirement.facialBiometrics.modal.help.learnMore.helpCenter') }}
        </XLink>
      </I18nT>
    </div>

    <small :class="$style.disclaimer">
      {{ t('requirement.facialBiometrics.modal.help.authMethod') }}
    </small>

    <template #actions>
      <XButton
        data-testid="facialBiometricsHelpModalButton"
        @click="closeModal"
      >
        {{ t('common.close') }}
      </XButton>
    </template>
  </XModal>
</template>

<style lang="scss" module>
.helpTextContainer {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: var(--space-large);
  gap: var(--space-small-xx);
}

.helpTitle {
  margin-bottom: 0;
}

.disclaimer {
  color: var(--color-neutral-700);
}

</style>
